import declare from "dojo/_base/declare";
import New from "csi/table/New";
import xml from "csi/xml";

const NewFoodBOMSection = declare(New, {

	/**
	 * @override
	 * Set value for BOM / placement product type and make it read only
	 */
	onCreatePopup: function (view) {
		view.addFixedValue("BOMProductType", "ProductType:Food");
		view.getField("SortOrder").m_bRequired = true;
		this.inherited(arguments);
	},
	/**
	 * @override
	 * Add Attributes To request
	 */
	toWriter: function () {
		this.inherited(arguments);
		this.m_writer.changeNode(this.m_urlNode)
			.changeAttribute("PlacementProductType", xml.ATTR_ENUM, "ProductType:Material")
			.changeAttribute("AdHoc", xml.ATTR_BOOLEAN, false);
	},
});

export = NewFoodBOMSection;